import { State } from '../../types';

export const california: State = {
  name: 'California',
  abbreviation: 'CA',
  terms: [
    {
      word: 'Agave',
      phonetic: 'uh-GAH-vee',
      description: 'A common desert plant name in the Southwest. Often mispronounced as "uh-GAH-vay."'
    },
    {
      word: 'Bernal Heights',
      phonetic: 'BURR-nul',
      // audioUrl: '/audio/napa.mp3',
      description: 'A residential neighborhood in San Francisco.'
    },
    {
      word: 'Camarillo',
      phonetic: 'kah-mah-REE-yoh',
      // audioUrl: '/audio/camarillo.mp3',
      description: 'A city in Ventura County, pronounced "kah-mah-REE-yoh," not "kah-mah-RILL-oh."'
    },
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'El Cajon',
      phonetic: 'Ell-kah-HONE',
      // audioUrl: '/audio/napa.mp3',
      description: 'A city east of San Diego.'
    },
    {
      word: 'Gough Street',
      phonetic: 'Goff street',
      // audioUrl: '/audio/napa.mp3',
      description: 'A street in San Francisco.'
    },
    {
      word: 'Jacumba',
      phonetic: 'yah-KUM-buh',
      // audioUrl: '/audio/jacumba.mp3',
      description: 'A small desert community in eastern San Diego County."'
    },
    {
      word: 'Jamacha',
      phonetic: 'Hah-mah-shaw',
      // audioUrl: '/audio/napa.mp3',
      description: 'A neighborhood and road in San Diego.'
    },
    {
      word: 'La Jolla',
      phonetic: 'la HOY-uh',
      // audioUrl: '/audio/napa.mp3',
      description: 'A seaside community in San Diego, often mispronounced as "La JOL-la."'
    },
    {
      word: 'Lee Vining',
      phonetic: 'Lee-Vy-ning',
      // audioUrl: '/audio/napa.mp3',
      description: 'A small town in Mono County that started as a gold mining camp by Leroy Vining.'
    },
    {
      word: 'Leucadia',
      phonetic: 'Loo-KAY-dee-ah',
      // audioUrl: '/audio/napa.mp3',
      description: 'A beachside community in Encinitas.'
    },
    {
      word: 'Lompoc',
      phonetic: 'lom-Poke',
      // audioUrl: '/audio/napa.mp3',
      description: 'A city near Vandenberg Space Force Base.'
    },
    {
      word: 'Los Feliz',
      phonetic: 'Lohs-Feh-LEEZ',
      // audioUrl: '/audio/napa.mp3',
      description: 'A neighborhood in Los Angeles.'
    },
    {
      word: 'Marin',
      phonetic: 'mah-RIN',
      // audioUrl: '/audio/napa.mp3',
      description: 'A county north of San Francisco.'
    },
    {
      word: "Mission Burrito",
      phonetic: "MIS-shun BUH-ree-toh",
      description: "A large burrito originating in the Mission District of San Francisco.",
    },
    {
      word: 'Napa',
      phonetic: 'NAP-uh',
      // audioUrl: '/audio/napa.mp3',
      description: 'Famous wine region in California'
    },
    {
      word: 'Noe Valley',
      phonetic: 'NO-ee Valley',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A neighborhood in San Francisco.'
    },
    {
      word: 'Ojai',
      phonetic: 'oh-Hi',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A small city in Ventura County.'
    },
    {
      word: 'Otay Mesa',
      phonetic: 'OH-tie MAY-suh',
      // audioUrl: '/audio/otay-mesa.mp3',
      description: 'An area in southern San Diego near the U.S.–Mexico border, pronounced "OH-tie," not "oh-TAY."'
    },
    {
      word: 'Paso Robles',
      phonetic: 'PASS-oh ROH-buhlz',
      // audioUrl: '/audio/paso_robles.mp3',
      description: 'A city in San Luis Obispo County, pronounced "PASS-oh ROH-buhlz," not "PAH-soh ROH-blays."'
    },
    {
      word: 'Palo Verde',
      phonetic: 'PAH-loh VEHR-day',
      description: 'A common Southwestern desert tree name. Often mispronounced as "PAL-oh VER-dee."'
    },
    {
      word: 'Petaluma',
      phonetic: 'pet-uh-LOO-muh',
      // audioUrl: '/audio/petaluma.mp3',
      description: 'A city in Sonoma County, pronounced "pet-uh-LOO-muh," not "pet-uh-LUM-uh."'
    },
    {
      word: 'Poway',
      phonetic: 'Pow-Way',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A city in San Diego County.'
    },
    {
      word: 'Rancho Peñasquitos',
      phonetic: 'Ranch-oh Pen-yah-skee-tohs',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A suburban area in northern San Diego.'
    },
    {
      word: 'San Rafael',
      phonetic: 'San ruh-FELL',
      // audioUrl: '/audio/napa.mp3',
      description: 'A city in California, commonly mispronounced as "San RAH-fy-el."'
    },
    {
      word: 'San Ysidro',
      phonetic: 'San ee-SEE-dro',
      // audioUrl: '/audio/napa.mp3',
      description: 'A district on the U.S.–Mexico border.'
    },
    {
      word: 'Sepulveda',
      phonetic: 'suh-PUL-vuh-duh',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'Major boulevard in Los Angeles'
    },
    {
      word: 'Siskiyou',
      phonetic: 'SISK-you',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A county in northern Califronia on the Oregon border.'
    },
    {
      word: 'Tehachapi',
      phonetic: 'tuh-HATCH-uh-pee',
      // audioUrl: '/audio/tehachapi.mp3',
      description: 'A city in Kern County, pronounced "tuh-HATCH-uh-pee," not "tee-hah-CHA-pee."'
    },
    {
      word: 'Tujunga',
      phonetic: 'Tuh-hunga',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A Los Angeles city neighborhood within the Crescenta Valley and Verdugo Mountains.'
    },
    {
      word: 'Tuolumne',
      phonetic: 'too-AW-luh-mee',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A county and river in northern California.'
    },
    {
      word: 'Upas Street',
      phonetic: 'YOO-pass street',
      // audioUrl: '/audio/upas-street.mp3',
      description: 'A street running along the north side of Balboa Park in San Diego, pronounced "YOO-pass," not "OO-pahs."'
    },
    {
      word: 'Vallejo',
      phonetic: 'vuh-LAY-oh',
      // audioUrl: '/audio/vallejo.mp3',
      description: 'A city in Solano County, pronounced "vuh-LAY-oh," not "vuh-LEE-joh."'
    },
    {
      word: 'Ventura',
      phonetic: 'Vent-ura',
      // audioUrl: '/audio/sepulveda.mp3',
      description: 'A coastal city north of LA commonly mispronounced "Venchura".'
    },
    {
      word: 'Yosemite',
      phonetic: 'Yoh-SEM-it-ee',
      // audioUrl: '/audio/napa.mp3',
      description: 'A world-famous national park'
    },
    {
      word: 'Zzyzx',
      phonetic: 'ZY-Zicks',
      // audioUrl: '/audio/napa.mp3',
      description: 'A small unincorporated municipality in San Bernardino County.'
    }
  ]
};
